"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Main = void 0;
var react_1 = __importDefault(require("react"));
var react_cookie_1 = require("react-cookie");
var query_string_1 = __importDefault(require("query-string"));
var const_1 = require("remota-common/const");
var structure_1 = require("remota-client/component/structure");
var panel_1 = require("remota-client/component/panel");
var form_1 = require("remota-client/component/form");
var button_1 = require("remota-client/component/button");
var auth_1 = require("app/hook/auth");
var Main = function (props) {
    var _a = query_string_1.default.parse(props.location.search.slice(1)), tenantCode = _a.tenantCode, redirect = _a.redirect;
    var _b = __read(react_1.default.useState({
        tenantCode: (Array.isArray(tenantCode) ? tenantCode[0] : tenantCode) || "",
        userCode: "",
        credential: "",
    }), 2), query = _b[0], setQuery = _b[1];
    var setCookie = (0, react_cookie_1.useCookies)([const_1.TOKEN_COOKIE_NAME])[1];
    var _c = __read((0, auth_1.useAuthenticate)(), 3), token = _c[0], authenticate = _c[1], status = _c[2];
    var handleChange = react_1.default.useCallback(function (e) {
        var _a = e.target, name = _a.name, value = _a.value;
        setQuery(function (query) {
            var _a;
            return (__assign(__assign({}, query), (_a = {}, _a[name] = value, _a)));
        });
    }, [setQuery]);
    var handleSubmit = react_1.default.useCallback(function () { return authenticate(query); }, [query, authenticate]);
    var handleKeyDown = react_1.default.useCallback(function (e) {
        // IME変換確定のEnterは無視する
        if (e.key !== "Enter" || e.nativeEvent.isComposing || status.isLoading) {
            return;
        }
        handleSubmit();
    }, [handleSubmit, status.isLoading]);
    if (token && !status.error && !status.isLoading) {
        // TODO: 有効期限など
        setCookie(const_1.TOKEN_COOKIE_NAME, token, { path: "/", secure: true });
        // もうちょっとかっこいいリダイレクトはないものか
        var url = Array.isArray(redirect) ? redirect[0] : redirect;
        window.location.assign(url && /^\//.test(decodeURIComponent(url)) ? decodeURIComponent(url) : "/");
    }
    var error = status.error !== null;
    return (react_1.default.createElement(structure_1.PlainStructure, { center: true },
        react_1.default.createElement(panel_1.LogoPanel, { width: 300 },
            react_1.default.createElement(structure_1.FormLineStructure, { label: "\u30ED\u30B0\u30A4\u30F3" },
                react_1.default.createElement(form_1.BoxInput, { "data-testid": "Login_TenantCode", type: "text", name: "tenantCode", value: query.tenantCode, onChange: handleChange, onKeyDown: handleKeyDown, error: error, placeholder: "\u30C6\u30CA\u30F3\u30C8\u30B3\u30FC\u30C9" })),
            react_1.default.createElement(structure_1.FormLineStructure, null,
                react_1.default.createElement(form_1.BoxInput, { "data-testid": "Login_UserCode", type: "text", name: "userCode", value: query.userCode, onChange: handleChange, onKeyDown: handleKeyDown, error: error, placeholder: "\u30E6\u30FC\u30B6\u30FCID" })),
            react_1.default.createElement(structure_1.FormLineStructure, null,
                react_1.default.createElement(form_1.BoxInput, { "data-testid": "Login_Credential", type: "password", name: "credential", value: query.credential, onChange: handleChange, onKeyDown: handleKeyDown, error: error, placeholder: "\u30D1\u30B9\u30EF\u30FC\u30C9" })),
            react_1.default.createElement(structure_1.FormLineStructure, null,
                react_1.default.createElement(button_1.AccentButton, { "data-testid": "Login_Submit", thin: true, disabled: status.isLoading, onClick: handleSubmit, width: "100%" }, "Login")),
            react_1.default.createElement(MessageArea, { error: status.error }))));
};
exports.Main = Main;
var MessageArea = react_1.default.memo(function (props) {
    var error = props.error;
    if (!error) {
        return null;
    }
    switch (error.message) {
        case const_1.ErrorMessage.INVALID_AUTH:
            return (react_1.default.createElement(structure_1.FormLineStructure, null,
                react_1.default.createElement(form_1.Message, { error: true }, "\u30ED\u30B0\u30A4\u30F3\u60C5\u5831\u304C\u9593\u9055\u3063\u3066\u3044\u307E\u3059")));
        case const_1.ErrorMessage.AUTH_SERVER_UNAVAILABLE:
            return (react_1.default.createElement(structure_1.FormLineStructure, null,
                react_1.default.createElement(form_1.Message, { error: true }, "Remota\u306B\u4E00\u6642\u7684\u306A\u554F\u984C\u304C\u767A\u751F\u3057\u3066\u3044\u307E\u3059")));
        default:
            return (react_1.default.createElement(structure_1.FormLineStructure, null,
                react_1.default.createElement(form_1.Message, { error: true }, "\u4E0D\u660E\u306A\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F")));
    }
});
